import React, { useEffect, createElement } from 'react';
import AdvertorialAdv2 from '../components/AdvertorialAdv2';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function Adv2Page() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your NEW Pixel ID for Adv2
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'Ozempic Depression Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'ReadHalfArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'ReadFullArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-2137">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-2138">
        <Helmet data-id="element-2139">
          <title data-id="element-2140">
            Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users
            Experiencing Severe Depression—And Why Isn't Anyone Talking About
            It?
          </title>
          <meta property="og:title" content="Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users Experiencing Severe Depression—And Why Isn't Anyone Talking About It?" data-id="element-2141" />
          <meta property="og:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-2142" />
          <meta property="og:type" content="article" data-id="element-2143" />
          <meta property="og:url" content={window.location.href} data-id="element-2144" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-2145" />
          <meta property="og:image:width" content="1200" data-id="element-2146" />
          <meta property="og:image:height" content="630" data-id="element-2147" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-2148" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-2149" />
          <meta name="twitter:title" content="Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users Experiencing Severe Depression—And Why Isn't Anyone Talking About It?" data-id="element-2150" />
          <meta name="twitter:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-2151" />
          <meta name="twitter:url" content={window.location.href} data-id="element-2152" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-2153" />
        </Helmet>
        <AdvertorialAdv2 data-id="element-2154" />
      </div>
    </HelmetProvider>;
}